import { h } from 'preact'

export default function notFoundView () {
  return h('div', { id: 'notFound' },
    h('h1', {}, '🤷‍♀️ Page not found 🤷‍♂️'),
    h('a', { href: '/app' }, 'Go home?')
  )
}
